import {observable} from 'mobx';

import QuestionModel from '../models/QuestionModel'


export default class QuestionStore {
    constructor(store) {
        this.store = store; //AppStore
    }

    @observable questions = {};

    importQuestions = (array) =>{
        array.forEach((el) => {
            this.questions[el.type] = el.questions.map((question) => {
                return QuestionModel.fromJS(this.store, question, el.type, question.icons);
            });
        });

        return this;
    };
}


// WEBPACK FOOTER //
// ./src/stores/QuestionStore.js